
import { handleShowSwalConfirmation } from '../../../utils/Helper';
import { RemoveProfileImageAction } from '../../../redux/Action/ProfileAction';
import { toast } from 'react-toastify';
import { useIntl } from 'react-intl';

// interface RemoveImageParams {
//     media_id: number | string | null; index: number; selectedImages: any[]; setSelectedImages: (images: any[]) => void;
//     setValue: UseFormSetValue<any>; trigger: UseFormTrigger<any>; dispatch: Dispatch;
// }
// interface HandleOwnerImageParams {
//     e: React.ChangeEvent<HTMLInputElement>;
//     setValue: UseFormSetValue<any>;
//     setOwnerImage: (file: File) => void;
//     validateImage: (file: File, validImageTypes: string[]) => string | true;
//     validImageTypes: string[];
// }

export const handleOwnerImageChange = ({ e, setValue, setOwnerImage, validateImage, validImageTypes }: any) => {
    const file = e.target.files?.[0];
    if (file) {
        const validationError = validateImage(file, validImageTypes);
        if (validationError !== true) {
            toast.error(validationError as string);
            return;
        }
        const imageURL = URL.createObjectURL(file);
        setValue("ownerimage", imageURL);
        setOwnerImage(file);
    }
};

// interface HandleImageParams {
//     e: React.ChangeEvent<HTMLInputElement>;
//     index: number;
//     selectedImages: any[];
//     setSelectedImages: (images: any[]) => void;
//     setValue: UseFormSetValue<any>;
//     trigger: UseFormTrigger<any>;
//     validateImage: (file: File, validImageTypes: string[]) => string | true;
//     validImageTypes: string[];
//     getImages: File[];
//     setGetImages: (images: File[]) => void;
// }

export const handleImageChange = ({ e, index, selectedImages, setSelectedImages, setValue, trigger, validateImage, validImageTypes, getImages, setGetImages }: any) => {
    const file = e.target.files?.[0];
    if (file) {
        const validationError = validateImage(file, validImageTypes);
        if (validationError !== true) {
            toast.error(validationError as string);
            return;
        }
        const updatedImages: any[] = [...selectedImages];
        updatedImages[index] = { file_path: file, media_id: updatedImages[index]?.media_id };
        setSelectedImages(updatedImages);

        const updatedGetImages = [...getImages];
        updatedGetImages[index] = file;
        setGetImages(updatedGetImages);

        const imageData = updatedImages.filter((img: any) => img.file_path);
        setValue('image', imageData.length >= 5 ? imageData : []);
        trigger("image");
    }
};


export const RemoveImage = async ({ media_id, index, selectedImages, setSelectedImages, setValue, trigger, dispatch }: any) => {
    let imageData: any[] = [];
    const intl = useIntl();

    // let confirmation = await handleShowSwalConfirmation("You want to remove this image?", true);
    let confirmation = await handleShowSwalConfirmation(intl.formatMessage({ id: 'you_want_to_remove' }), true, true, intl.formatMessage({ id: 'are_you_sure' }));

    if (confirmation) {

        let updatedImages;

        if (media_id) {
            updatedImages = selectedImages.filter((img: any) => img.media_id !== media_id);
        } else {
            updatedImages = [...selectedImages];
            updatedImages.splice(index, 1);
        }

        

        setSelectedImages([...updatedImages, { file_path: null, media_id: null }]);
        // setSelectedImages(updatedImages);
        imageData = updatedImages.filter((item: any) => item?.file_path != null);

        if (imageData.length >= 5) {
            setValue('image', imageData);
        }
        else {
            setValue('image', []);
        }
        trigger("image");

        if (media_id) {
            dispatch(RemoveProfileImageAction({ delete_id: media_id }));
        }
    }
};
